import { memoizeFunction, mergeStyleSets } from '@fluentui/react';
import { IAppTheme, useAppTheme } from 'common/theme/AppTheme';

import { containerHeight, containerWidth } from './Avatar.styles';

/**
 * @private
 */
const baseline = 8;

/**
 * @private
 */
const spacing = {
  xxl: baseline * 4.5,
  md: baseline * 2,
  xs: baseline,
  xxs: baseline / 2,
} as const;

export const getStyles = memoizeFunction(({ palette }: IAppTheme, isSelected: boolean, baseSize: number, isAddStatus: boolean) => {
  const barHeight = spacing.xxs;

  return mergeStyleSets({
    bar: {
      alignSelf: 'center',
      backgroundColor: palette.themePrimary,
      borderRadius: spacing.xs,
      bottom: spacing.xs,
      display: 'block',
      height: barHeight,
      width: spacing.xxl,
    },
    button: {
      border: 0,
      background: 'transparent',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      height: containerHeight,
      padding: 0,
      margin: 0,
      '&:hover': {
        cursor: 'pointer',
      },
    },

    /**
     * Dashboard V2 Styles
     */
    wrapper: {
      height: '100%',
      '&:hover': {
        cursor: 'pointer',
      },
      '& > div': {
        position: 'relative',
      },
    },
    artifactWrapper: {
      width: `${baseSize + 4}px`, // add 4px for 2px border on each side
      height: 'auto',
      margin: `${spacing.xs}px`,
      opacity: isAddStatus ? 0.5 : 1,
    },
    addIcon: {
      bottom: `${spacing.xs}px`,
      right: `${spacing.xs}px`,
      position: 'absolute',
    },
    textWrapper: {
      marginBottom: `${spacing.md}px`,
    },
    nameLabel: {
      textAlign: 'center',
      width: containerWidth,
      maxWidth: '15ch',
      paddingBottom: isSelected ? `${spacing.xs}px` : `${spacing.xs + barHeight}px`,
    },
  });
});

export const useStyles = (isSelected: boolean, baseSize: number, isAddStatus: boolean) => {
  const theme = useAppTheme();
  return getStyles(theme, isSelected, baseSize, isAddStatus);
};
